import styled from "styled-components";
import { ListItemIcon, ListItem, ListItemText } from "@material-ui/core";
import { TypeAppliedTheme } from "@src/Stores/Themes/types";

export const STListItemIcon = styled(ListItemIcon)`
  &&& {
    margin-right: 0px;
    color: ${(props: { theme: TypeAppliedTheme }) => props.theme.secondaryTextColor};
    min-width: 0;
  }
`;

export const STListItem = styled(ListItem)`
  && {
    :hover {
      cursor: pointer;
    }
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

export const STListItemText = styled(ListItemText)`
  && {
    color: ${(props: { theme: TypeAppliedTheme }) => props.theme.secondaryTextColor};
    padding: 0 16px;
    margin: 0;
  }
`;
